import { MoneyFormatter } from "../../MoneyFormatter";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { Translator } from "../../Translator";
import { Size } from "../.././MyHelpers";
import { SlotBonus3 } from "../Bonus/SlotBonus3";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { BonusFinish, IBonusStartConfig } from "../SlotGame";
//import { FreegameConfiguration } from "./FreegameConfiguration";
import { Settings } from "../../Settings";
import { FreegamesCommonConfiguration } from "../../api";

export interface FreegameBonus3Params extends SlotBonusParams {
    readonly gameName: string;
    readonly gameBonusResourcesBasePath: string;
    readonly commonBonusResourcesBasePath: string
    readonly viewSize: Size;
    readonly bonusConfiguration: FreegamesCommonConfiguration;
}

export class FreeGameBonus3 extends SlotBonus3 implements Resourceful2 {

    public static readonly BonusName: string = "FreeGameBonus";

    protected view: HTMLElement = null;
    protected override resid: ResourceIdentifier;
    protected override parentresid: ResourceIdentifier = null;
    protected basepath: string = null;

    protected params: FreegameBonus3Params = null;
    protected gameResourcesBasePath: string;
    protected commonResourcesBasePath: string;
    protected viewSize: Size;

    protected moneyFormatter: MoneyFormatter = null;
	protected translator: Translator;
	
	protected BonusName(): string
	{
		return "FreeGameBonus";
	}

    constructor(gameResid: ResourceIdentifier, params: FreegameBonus3Params) {
        super(params.gameName, params);

        this.parentresid = gameResid;
        this.resid = gameResid.Add(this.bonusName + "3");

        this.params = params;
        this.gameResourcesBasePath = params.gameBonusResourcesBasePath;
        this.commonResourcesBasePath = params.commonBonusResourcesBasePath;
        this.viewSize = params.viewSize;

        this.basepath = Settings.ResourcesFolder + "../../slot/" + params.gameName + "/";

        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.style.position = "absolute";
        this.view.style.top = "0px";
        this.view.style.left = "0px";
        this.view.style.width = this.viewSize.Width + "px";
        this.view.style.height = this.viewSize.Height + "px";
    }

    public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.Add(new ImageResource(this.gameResourcesBasePath + "background.3.png", this.resid.ScopedResourceName(["background3", "image"])));
    }

    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
        //this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background3", "image"])).CssBackground();
    }

    public OnBonusFinish(bonusFinish: BonusFinish): void {
    }

    public Prepare(bonusStartConfig: IBonusStartConfig): void {
    }

    public Hide(): void {
        this.view.style.visibility = "hidden";
    }

    public Show(): void {
        this.view.style.visibility = "visible";
    }

    public Update(): void {
    }

    public View(): HTMLElement {
        return this.view;
    }

    public Start(): void {
        this.Reset();
    }

    public Stop(): void {
    }

    public Reset(): void {
    }
}
